import { getTranslatedSortTitles, SortField, WhitelistSortFields } from 'component/page/search/SortAndFilter/Sort/SortCard.types';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { Sort } from 'gql/autogen/Sort';
import { SortMatrix } from 'gql/autogen/SortMatrix';
import { SortCode } from 'gql/autogen/SortCode';
import { SortOrder } from 'gql/autogen/SortOrder';
import { SortItemProps } from 'component/common/SortItem/SortItem';

export const getSortCodeOrder = (sortState: Sort) => `${sortState.code}_${sortState.order}` as SortField;

const createSortItem = (code: SortCode, order: SortOrder, cms: CmsValue, currentSort?: Sort): SortItemProps => {
    const type = `${code}_${order}` as SortField;
    const label = getTranslatedSortTitles(cms)[type];

    return {
        label,
        type,
        code,
        order,
        name: 'sort',
        selected: (code === SortCode.Default && !currentSort?.code) || (currentSort?.code === code && currentSort.order === order),
    };
};

export const getSortItems = (cms: CmsValue, sortDetail: SortMatrix, currentSort?: Sort): SortItemProps[] => {
    if (!sortDetail?.availableOrder?.length) {
        return [];
    }

    const supportedSortFields: string[] = [];
    sortDetail.availableCode?.forEach((code) => {
        sortDetail.availableOrder?.forEach((order) => {
            supportedSortFields.push(`${code}_${order}`);
        });
    });

    const sortFieldsToDisplay: string[] = [];
    WhitelistSortFields.forEach((sortField) => {
        if (supportedSortFields.find((s) => s === sortField)) {
            sortFieldsToDisplay.push(sortField);
        }
    });

    const result = sortFieldsToDisplay.map((value: string) => {
        const split = value.split('_');
        return createSortItem(split[0] as SortCode, split[1] as SortOrder, cms, currentSort);
    });

    const sortItems = createSortItem(SortCode.Default, SortOrder.Default, cms, currentSort);
    return [sortItems, ...result];
};
